// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import axios from "axios";
// import { RiDeleteBin6Line } from "react-icons/ri";
// import { useAuth } from "../context/AuthContext";

// const API_BASE = "http://3.236.217.225:5001/api/planeacion";

// export default function ActividadesList({ logro }) {
//   const { user, token } = useAuth();
//   const [actividades, setActividades] = useState([]);
//   const [nuevaActividad, setNuevaActividad] = useState("");
//   const [loading, setLoading] = useState(false);

//   const api = useMemo(() => {
//     const instance = axios.create({ baseURL: API_BASE, withCredentials: true });
//     instance.interceptors.request.use(config => {
//       if (token) config.headers.Authorization = `Bearer ${token}`;
//       if (user?.tenant_id) config.headers["X-Tenant-ID"] = user.tenant_id;
//       if (user?.sede_id) config.headers["X-Sede-ID"] = user.sede_id;
//       return config;
//     });
//     return instance;
//   }, [token, user]);

//   const fetchActividades = useCallback(async () => {
//     if (!logro?.id) return;
//     setLoading(true);
//     try {
//       const { data } = await api.get(`/actividades/${logro.id}`);
//       setActividades(Array.isArray(data) ? data : []);
//     } catch { setActividades([]); } finally { setLoading(false); }
//   }, [logro?.id, api]);

//   useEffect(() => { 
//     fetchActividades(); 
//     setNuevaActividad(""); // Limpia el input al cambiar de logro
//   }, [fetchActividades]);

//   const handleAddActividad = async () => {
//     if (!nuevaActividad.trim()) return alert("Escribe el nombre de la actividad");
//     if (!logro?.id) return alert("Selecciona un logro primero");

//     try {
//       await api.post("/actividades", {
//         logro_id: logro.id,
//         nombre: nuevaActividad,
//         descripcion: "",
//         porcentaje: 0,
//         fecha_entrega: null,
//         tenant_id: user.tenant_id,
//         sede_id: user.sede_id,
//         profesor_id: user.id
//       });
//       setNuevaActividad(""); // Limpiar campo
//       fetchActividades();    // Refrescar lista
//     } catch (err) {
//       alert("Error al crear la actividad");
//     }
//   };

//   return (
//     <div className="box">
//       <h3>📌 Actividades</h3>
//       {!logro?.id ? (
//         <p className="muted">Seleccione un logro para gestionar sus actividades</p>
//       ) : (
//         <>
//           <div className="form small">
//             <input 
//               placeholder="Escriba la nueva actividad..." 
//               value={nuevaActividad}
//               onChange={(e) => setNuevaActividad(e.target.value)}
//             />
//             <button className="btn-primary" onClick={handleAddActividad}>Agregar</button>
//           </div>
          
//           <div className="list">
//             {loading ? <p>Cargando...</p> : actividades.map(a => (
//               <div key={a.id} className="list-item">
//                 <div><strong>{a.nombre}</strong></div>
//               </div>
//             ))}
//             {!loading && actividades.length === 0 && <p className="muted">No hay actividades para este logro.</p>}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }


import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useAuth } from "../context/AuthContext";
import { API } from "../components/config";

const API_BASE = `${API}/planeacion`;

export default function ActividadesList({ logro }) {
  const { user, token } = useAuth();

  const [actividades, setActividades] = useState([]);
  const [nuevaActividad, setNuevaActividad] = useState("");

  /* =========================
     AXIOS CONFIG (MULTITENANT)
  ========================= */
  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: API_BASE,
      withCredentials: true,
    });

    instance.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;

      config.headers["X-Tenant-ID"] =
        user?.tenant_id || user?.institucion_id || "";

      config.headers["X-Sede-ID"] = user?.sede_id || "";

      return config;
    });

    return instance;
  }, [token, user]);

  /* =========================
     CARGAR ACTIVIDADES
  ========================= */
  const fetchActividades = useCallback(async () => {
    if (!logro?.id) {
      setActividades([]);
      return;
    }

    try {
      const { data } = await api.get(`/actividades/${logro.id}`);
      setActividades(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("❌ Error cargando actividades:", err);
      setActividades([]);
    }
  }, [api, logro?.id]);

  useEffect(() => {
    fetchActividades();
    setNuevaActividad("");
  }, [fetchActividades]);

  /* =========================
     CREAR ACTIVIDAD (FIX 400)
  ========================= */
  const add = async () => {
    if (!nuevaActividad.trim()) {
      return alert("Escribe el nombre de la actividad");
    }

    if (!logro?.id) {
      return alert("Selecciona un logro primero");
    }

    try {
      await api.post("/actividades", {
        logro_id: logro.id,

        // 🔥 ESTO ES LO QUE TU BACKEND ESTÁ EXIGIENDO
        titulo: nuevaActividad.trim(),
        descripcion: "",

        // 🔥 CLAVE PARA EVITAR "Datos obligatorios"
        grado: logro.grado,
        grupo: logro.grupo,
        materia_id: logro.materia_id,
        periodo_id: logro.periodo_id,
        item_id: logro.item_id,

        // multitenant
        profesor_id: user?.id,
        tenant_id: user?.tenant_id || user?.institucion_id,
        sede_id: user?.sede_id,
      });

      setNuevaActividad("");
      fetchActividades();
    } catch (err) {
      console.error("❌ ERROR BACKEND:", err.response?.data || err.message);

      alert(
        err.response?.data?.msg ||
        err.response?.data?.message ||
        "Error creando actividad (revisar backend)"
      );
    }
  };

  /* =========================
     ELIMINAR ACTIVIDAD
  ========================= */
  const del = async (id) => {
    if (!window.confirm("¿Eliminar esta actividad?")) return;

    try {
      await api.delete(`/actividades/${id}`);
      fetchActividades();
    } catch (err) {
      console.error("❌ Error eliminando:", err);
      alert("No se pudo eliminar");
    }
  };

  /* =========================
     UI
  ========================= */
  return (
    <div className="box">
      <h3>📌 Actividades</h3>

      {!logro?.id ? (
        <p>Seleccione un logro</p>
      ) : (
        <>
          <div style={{ display: "flex", gap: "8px" }}>
            <input
              value={nuevaActividad}
              onChange={(e) => setNuevaActividad(e.target.value)}
              placeholder="Nueva actividad"
            />

            <button onClick={add}>Agregar</button>
          </div>

          <div style={{ marginTop: "10px" }}>
            {actividades.length === 0 ? (
              <p>No hay actividades</p>
            ) : (
              actividades.map((a) => (
                <div
                  key={a.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "6px 0",
                  }}
                >
                  <span>{a.titulo || a.nombre}</span>

                  <button onClick={() => del(a.id)}>
                    <RiDeleteBin6Line />
                  </button>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}
